import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CompanyUtilityService {
    // This flag is used to enable Description and fees info component. This will be activated when we create company or if we have company ID
    isInputCompanyIdAvailable: boolean;

    // TO identify that the current page is for associate or parent
    isAssociateTab: boolean;

    //Domain validity patterns
    domainPatterns: RegExp = new RegExp('(?!pl)(^[a-z0-9]+[\-\.]{1}imagility.co)$','i');

    constructor() {
        this.isAssociateTab = false;
    }

    public compIdDataSource = new BehaviorSubject<any>({ isInputCompanyIdAvailable: false });

    checkCompanyIdFlag() {
        if (sessionStorage.getItem('selectedCompanyId')) {
            this.compIdDataSource.next({ isInputCompanyIdAvailable: true });
        }
        else {
            this.compIdDataSource.next({ isInputCompanyIdAvailable: false });
        }
    }

    isCompIdAvailable() {
        return this.compIdDataSource.asObservable();
    }

    setTab(flag: boolean) {
        this.isAssociateTab = flag;
    }

    getTab() {
        return this.isAssociateTab;
    }

}
